import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { useCallback } from 'react';

const HeroSection = () => {
  const handleExploreServices = useCallback(() => {
    const target = document.getElementById('spotify-section');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);
  
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden ">
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video 
          controls={false}
          className="w-full h-full object-cover no-overlay"
          src={'https://res.cloudinary.com/dhjzae1cm/video/upload/v1757240792/music_marketing_video_1_gkbhb0.mp4'}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          onCanPlay={(e) => e.target.play()}
        />
         {/* <DotLottieReact
      src="https://rummy-assets.jungleerummy.com/assets/audio_video_page_hero_video_gif_2025_video_json_gif_876882228968a3589806594.json"
      width="100vw"
      height="100vh"
      loop
      autoplay
    /> */}
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto  md:mt-0">
        {/* Main Heading */}
        <h1 className="text-[36px] md:text-[84px] font-normal
 text-white leading-tight mb-6 md:mb-0 max-w-6xl  mt-0  md:mt-[100px]">
Music Marketing
          <br />
          {/* <span className="">
            PRODUCTION
          </span> */}
        </h1>

        {/* Subtitle */}
        <p className="text-[18px] md:text-[20px] text-white mb-8 max-w-2xl mx-auto font-light">
         We create real campaigns that drive real results.
        </p>

        <div className="md:flex flex-row gap-4 mb-4 md:mb-12 justify-center">
          <button 
            onClick={handleExploreServices}
            className="flex-1 block md:inline-block w-[100%]  md:max-w-[180px] bg-[#FF8000] text-white py-[16px] px-[28px] rounded-xl hover:shadow-xl hover:shadow-orange-500/50 hover:scale-105 transition-all duration-300 text-[14px] md:text-[16px] font-normal !leading-[normal]"
          >
            Explore Services
          </button>
          <button onClick={() => window.location.href = '/contact'} className="flex-1 w-[100%] md:max-w-[180px] block md:inline-block backdrop-blur-sm border border-white text-white py-[16px] px-[28px] rounded-xl hover:bg-white/30 hover:border-white/50 hover:scale-105 transition-all duration-300 text-[14px] md:text-[16px] font-normal !leading-[normal] mt-[28px] md:mt-0">
            Contact Us
          </button>
        </div>
      </div>

    
    </section>
  );
};

export default HeroSection;